import { render, staticRenderFns } from "./TooltipTableHeader.vue?vue&type=template&id=987780d8&scoped=true&"
import script from "./TooltipTableHeader.vue?vue&type=script&lang=js&"
export * from "./TooltipTableHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "987780d8",
  null
  
)

export default component.exports